export default __webpack_public_path__ + "static/media/dontknow.0929a421.png";